<template>
  <div>
    <label v-if="label" class="pl-2 label-text">
      {{ label }}
      <v-icon v-if="required" class="uikit-icon mini-star size-mini-star error" />
    </label>
    <v-file-input
      v-model="dataValue"
      outlined dense class="rounded-lg mt-1 mini-text field-edit"
      :min-height="20"
      :placeholder="placeholder"
      :disabled="disabled"
      :class="errorMessages && errorMessages.length ? 'field-error' : ''"
      :hide-details="hideDetails"
      :error-messages="errorMessages"
      :hint="hint"
      :persistent-hint="persistentHint"
      :loading="loading"
      prepend-icon=""
      @change="changeData"
    >
      <div slot="append-outer">
        <v-icon class="uikit-icon paperclip lightGrey" />
      </div>
    </v-file-input>
  </div>
</template>

<script>
export default {
  name: 'UIFileInput',

  props: {
    label: {
      type: String,
      default: '',
    },
    value: {
      type: [File, Object],
      default: null,
    },
    errorMessages: {
      type: Array,
      default: null,
    },
    required: {
      type: Boolean,
      default: false,
    },
    hideDetails: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: 'Выберите файл',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    hint: {
      type: String,
      default: '',
    },
    persistentHint: {
      type: Boolean,
      default: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({ dataValue: null }),

  methods: {
    changeData(val) {
      if (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      } else {
        this.$emit('removeFile')
      }
    },
  },

  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.dataValue = val
      },
    },
  },
}
</script>
